(function () {
    'use strict';

    angular
        .module('ActionManager')
        .factory('action-request', actionFunc);

    function actionFunc(GenericModel, $q, lodash) {
        const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.
        return function(options, data, actionResponseData) {
            // Todo: This request action may encounter issue when during doing api call against child state
            // E.g, put to /candidates/1/profiles/23. Need to find ways to put in those into the param portion of the request.
            const deferred = $q.defer();
            if (!lodash.has(options, 'url')) {
                deferred.reject('No Endpoint specified');
                return deferred;
            }

            let postData = data;
            if (lodash.has(options, 'useActionResponse') && options.useActionResponse === true) {
                postData = actionResponseData;
            }

            let endpoint = decodeURI(options.url).replace(urlReplacerRegex, (match, submatch) => {
                return lodash.get(postData, submatch, '');
            });

            const method = lodash.get(options, 'method', 'get');
            const resource = new GenericModel(endpoint);
            const finalPostData = lodash.extend({}, postData);

            if (method === 'get') {
                return resource[method](finalPostData).$promise;
            } else {
                return resource[method]({}, {'data':finalPostData}).$promise;
            }
        };
    }
})();